import { h } from '../pragma.mjs';

export default () => {

    return (
        <div>

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikZapisy" href="#">Zápisy</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Změna dalších údajů o právech, poznámkách a upozorněních</strong></li>
                </ul>
            </gov-breadcrumbs>
            
            <gov-tiles>
                {/* <gov-tile class="gray_card" id="toastPoznamky" href="#">
                    <p>Poznámka spornosti, poznámky vztající se k zástavnímu právu, nařízení předběžného opatření, poznámka o výhradě, že upevněný stroj nebo jiné upevněné zařízení není součástí nemovitosti, souhlas se zatížením práva stavby, poznámka o uzavření smlouvy o provedení dražby nedobrovolné, exekuce ...</p>
                    <h3 slot="title">Poznámky</h3>
                    <gov-icon type="complex" name="doc-judgment" slot="icon"></gov-icon>
                </gov-tile> */}
                <gov-tile id="rozcestnikZapsatS8422" href="#">
                    <p>Výmaz podle § 62 odst. 4 katastrálního zákona na podkladě notářského zápisu</p>
                    <h3 slot="title">Výmaz věcného břemene převzatého z bývalé pozemkové knihy</h3>
                    <gov-icon type="complex" name="doc-petition" slot="icon"></gov-icon>
                </gov-tile>
                {/* <gov-tile id="rozcestnikZapsatS8421" href="#">
                    <p>Žádost o zápis upozornění (nejedná se o stížnosti podle části páté Správního řádu)</p>
                    <h3 slot="title">Žaloba, dovolání, stížnost, námitka, upozornění na závazek zástavního věřitele ...</h3>
                    <gov-icon type="complex" name="court" slot="icon"></gov-icon>
                </gov-tile> */}
            </gov-tiles>
        </div>
    )

}